<br><br>

<ngb-accordion #acc="ngbAccordion" (panelChange)="onAccordionClick($event)" [activeIds]="expandIds">
	<ngb-panel title="{{ 'adminstat.common.Filters' | translate }}" [id]="'filter'">
		<ng-template ngbPanelContent>
			
			<!--ROW 1-->
			<div class="row">
				
				<!--DATE FILTERS-->
				<div class="col-xl-4 col-lg-6 col-md-12 padding-bottom">
					<ngb-accordion #acc="ngbAccordion" (panelChange)="onAccordionClick($event)" [activeIds]="expandIds">
						<ngb-panel title="{{ 'adminstat.common.Date' | translate }}" [id]="'date'">
							<ng-template ngbPanelContent>
								<form class="form-horizontal">
									<div *ngFor="let dateType of filter.filterParams.dateFilterParams | keys" class="form-group">
										<div class="row">
											<div class="col-xl-6 col-lg-12 control-label">
												<h6>
													{{ 'adminstat.filterForm.' + dateType | translate }}
												</h6>
											</div>
											
											<div class="col-xl-6 col-lg-12">
												<select
													class="form-control"
													[(ngModel)]="filter.filterParams.dateFilterParams[dateType].type"
													[ngModelOptions]="{standalone: true}"
													[sextant]="'filter-dateType.' + dateType"
												>
													<option
														*ngFor="let opt of ['all', 'now', 'yesterday', 'prevWeek', 'prevMonth', 'last7day', 'last30day', 'allTime', 'other']"
														value="{{ opt }}"
														[selected]="opt == filter.filterParams.dateFilterParams[dateType].type"
													>
														{{ 'adminstat.common.interval.' + opt | translate }}
													</option>
												</select>
												
												<table>
													<tr
														[style.display]="filter.filterParams.dateFilterParams[dateType].type != 'other' ? 'none' : null"
													>
														<td>
															<datepicker
																[(ngModel)]="filter.filterParams.dateFilterParams[dateType].start"
																[ngModelOptions]="{standalone: true}"
																[format]="'DD-MM-YYYY'"
																[sextant]="'filter-dateType.' + dateType + '.start'"
															></datepicker>
															
															<datepicker
																[(ngModel)]="filter.filterParams.dateFilterParams[dateType].end"
																[ngModelOptions]="{standalone: true}"
																[format]="'DD-MM-YYYY'"
																[sextant]="'filter-dateType.' + dateType + '.end'"
															></datepicker>
														</td>
													</tr>
												</table>
											</div>
										</div>
									</div>
								</form>
							</ng-template>
						</ngb-panel>
					</ngb-accordion>
				</div>
				
				
				<!--TYPE OF USERS FILTERS-->
				<div class="col-xl-4 col-lg-6 col-md-12 padding-bottom">
					<ngb-accordion #acc="ngbAccordion" (panelChange)="onAccordionClick($event)" [activeIds]="expandIds">
						<ngb-panel title="{{ 'adminstat.filterForm.userType' | translate }}" [id]="'user-type'">
							<ng-template ngbPanelContent>
								<form class="form-horizontal">
								
									<!--userType-->
									<div class="form-group">
										<div class="row">
											<h6 class="col-xl-6 col-lg-12 control-label">{{ 'adminstat.common.User' | translate }}</h6>
											<div class="col-xl-6 col-lg-12">
												<select class="form-control" [(ngModel)]="filter.filterParams.userType" [ngModelOptions]="{standalone: true}" [sextant]="'filter-userType'">
													<option *ngFor="let opt of ['all', 'admin', 'user']"
															value="{{ opt }}" [selected]="opt == filter.filterParams.userType">{{ 'adminstat.filterForm.' + opt | translate }}
													</option>
												</select>
											</div>
										</div>
									</div>
	
									<!--userPaidType-->
									<div class="form-group">
										<div class="row">
											<h6 class="col-xl-6 col-lg-12 control-label">{{ 'adminstat.filterForm.userPaidType' | translate }}</h6>
											<div class="col-xl-6 col-lg-12">
												<select
													class="form-control"
											        [(ngModel)]="filter.filterParams.userPaidType"
											        [ngModelOptions]="{standalone: true}"
											        (input)="onUserPaidTypeChange($event.target.value)"
											        [sextant]="'filter-userPaidType'"
												>
													<option
														*ngFor="let opt of ['all'].concat(userPaidStatusList)"
														value="{{ opt }}"
														[selected]="opt == filter.filterParams.userPaidType"
													>
														{{ 'adminstat.filterForm.' + opt | translate }}
													</option>
												</select>
												
												<table *ngIf="filter.filterParams.userPaidType === 'uncompBacket'">
													<tr>
														<td>
															<datepicker [(ngModel)]="filter.filterParams.dateFilterParams.uncompBacketTime.start" [ngModelOptions]="{standalone: true}" [format]="'DD-MM-YYYY'"></datepicker>
															<datepicker [(ngModel)]="filter.filterParams.dateFilterParams.uncompBacketTime.end" [ngModelOptions]="{standalone: true}" [format]="'DD-MM-YYYY'"></datepicker>
														</td>
													</tr>
												</table>
											</div>
										</div>
									</div>
	
									<!--lang-->
									<div class="form-group">
										<div class="row">
											<h6 class="col-xl-6 col-lg-12 control-label">{{ 'adminstat.common.created language' | translate }}</h6>
											<div class="col-xl-6 col-lg-12">
												<select class="form-control" [(ngModel)]="filter.filterParams.lang" [ngModelOptions]="{standalone: true}" [sextant]="'filter-lng'">
													<option *ngFor="let opt of localesMap | keys"
															value="{{ opt }}" [selected]="opt == filter.filterParams.lang">{{ localesMap[opt] }}
													</option>
												</select>
											</div>
										</div>
									</div>

									<!--device-->
									<div class="form-group">
										<div class="row">
											<h6 class="col-xl-6 col-lg-12 control-label">Устройство регистрации</h6>
											<div class="col-xl-6 col-lg-12">
												<select class="form-control" [(ngModel)]="filter.filterParams.userCreatedDevice" [ngModelOptions]="{standalone: true}" [sextant]="'filter-userCreatedDevice'">
													<option *ngFor="let opt of createdDevices | keys"
															value="{{ opt }}" [selected]="opt == filter.filterParams.userCreatedDevice">{{ createdDevices[opt] }}
													</option>
												</select>
											</div>
										</div>
									</div>
									
									<!-- dashboard land -->
									<div class="form-group">
										<div class="row">
											<h6 class="col-xl-6 col-lg-12 control-label">{{ 'adminstat.common.auth language' | translate }}</h6>
											<div class="col-xl-6 col-lg-12">
												<select class="form-control" [(ngModel)]="filter.filterParams.authLang" [ngModelOptions]="{standalone: true}" [sextant]="'filter-dash-lng'">
													<option *ngFor="let opt of localesMap | keys"
													        value="{{ opt }}" [selected]="opt == filter.filterParams.authLang">{{ localesMap[opt] }}
													</option>
												</select>
											</div>
										</div>
									</div>
									
									
									<div class="form-group">
										<div class="row">
											<div class="col-xl-6 col-lg-12">
												<h6 class="control-label">
													{{ 'adminstat.common.country by auth' | translate }}
												</h6>
											</div>
											
											<div class="col-xl-6 col-lg-12">
												<ng-selectize
													[sextant]="'filter-countries'"
													[config]="selectizeLocation.config"
													[options] = "selectizeLocation.options"
													[(ngModel)]="filter.filterParams.countries"
													[ngModelOptions]="{standalone: true}"
												>
												</ng-selectize>
											</div>
										</div>
									</div>
									
									
									<div class="form-group">
										<div class="row">
											<div class="col-xl-6 col-lg-12">
												<h6 class="control-label">
													{{ 'adminstat.mails.mailer.city' | translate }}
												</h6>
											</div>
											
											<div class="col-xl-6 col-lg-12">
												<ng-selectize
													[sextant]="'filter-cities'"
													[enabled]="filter.filterParams.countries.length > 0"
													[config]="selectizeCity.config"
													[options] = "selectizeCity.options"
													[(ngModel)]="filter.filterParams.cities"
													[ngModelOptions]="{standalone: true}"
												>
												</ng-selectize>
											</div>
										</div>
									</div>
									
									<!-- user phone -->
									<div class="form-group">
										<div class="row">
											<h6 class="col-xl-6 col-lg-12 control-label">{{ 'adminstat.filterForm.isUserHasDashboadPhone' | translate }}</h6>
											<div class="col-xl-6 col-lg-12">
												<div class="checkbox">
													<label>
														<input
															type="checkbox"
															[(ngModel)]="filter.filterParams.isUserHasDashboadPhone"
															[ngModelOptions]="{standalone: true}"
															[attr.checked]="filter.filterParams.isUserHasDashboadPhone"
														>
													</label>
												</div>
											</div>
										</div>
									</div>
									
									<!--countReReg-->
									<div class="form-group">
										<div class="row">
											<h6 class="col-xl-6 col-lg-12 control-label">{{ 'adminstat.filterForm.countReReg' | translate }}</h6>
											<div class="col-xl-6 col-lg-12">
												<div class="checkbox">
													<label>
														<input type="checkbox" [(ngModel)]="filter.filterParams.countReReg" [ngModelOptions]="{standalone: true}" [attr.checked]="filter.filterParams.countReReg">
													</label>
												</div>
											</div>
										</div>
									</div>
									
									<!-- UKIT-14168 -->
									<div class="form-group">
										<div class="row">
											<h6 class="col-xl-6 col-lg-12 control-label">{{ 'adminstat.filterForm.excludeRereg' | translate }}</h6>
											<div class="col-xl-6 col-lg-12">
												<div class="checkbox">
													<label>
														<input type="checkbox" [(ngModel)]="filter.filterParams.excludeRereg" [ngModelOptions]="{standalone: true}" [attr.checked]="filter.filterParams.excludeRereg">
													</label>
												</div>
											</div>
										</div>
									</div>

									<!-- UKIT-28065 -->
									<div class="form-group">
										<div class="row">
											<h6 class="col-xl-6 col-lg-12 control-label">{{ 'adminstat.filterForm.excludeBanned' | translate }}</h6>
											<div class="col-xl-6 col-lg-12">
												<div class="checkbox">
													<label>
														<input type="checkbox" [(ngModel)]="filter.filterParams.excludeBanned" [ngModelOptions]="{standalone: true}" [attr.checked]="filter.filterParams.excludeBanned">
													</label>
												</div>
											</div>
										</div>
									</div>

									<!-- UKIT-28065 -->
									<div class="form-group">
										<div class="row">
											<h6 class="col-xl-6 col-lg-12 control-label">{{ 'adminstat.filterForm.excludeBlocked' | translate }}</h6>
											<div class="col-xl-6 col-lg-12">
												<div class="checkbox">
													<label>
														<input type="checkbox" [(ngModel)]="filter.filterParams.excludeBlocked" [ngModelOptions]="{standalone: true}" [attr.checked]="filter.filterParams.excludeBlocked">
													</label>
												</div>
											</div>
										</div>
									</div>

									<!-- exclude bots -->
									<div class="form-group">
										<div class="row">
											<h6 class="col-xl-6 col-lg-12 control-label">{{ 'adminstat.filterForm.excludeBot' | translate }}</h6>
											<div class="col-xl-6 col-lg-12">
												<div class="checkbox">
													<label>
														<input type="checkbox" [(ngModel)]="filter.filterParams.excludeBot" [ngModelOptions]="{standalone: true}" [attr.checked]="filter.filterParams.excludeBot">
													</label>
												</div>
											</div>
										</div>
									</div>
									
									<!-- isExcluded -->
									<div class="form-group">
										<div class="row">
											<h6 class="col-xl-6 col-lg-12 control-label">
												{{ 'adminstat.common.isShowExcluded' | translate }}
											</h6>
											
											<div class="col-xl-6 col-lg-12">
												<select
													class="form-control"
													[(ngModel)]="filter.filterParams.isShowExcluded"
													[ngModelOptions]="{standalone: true}"
													[sextant]="'filter-isShowExcluded'"
												>
													<option
														*ngFor="let opt of ['', 'false', 'true']"
														value="{{ opt }}"
														[selected]="opt == filter.filterParams.isShowExcluded"
													>
														{{ 'adminstat.filterForm.' + opt | translate }}
													</option>
												</select>
											</div>
										</div>
									</div>
								</form>
							</ng-template>
						</ngb-panel>
					</ngb-accordion>
				</div>

				<!--REFERER FILTERS-->
				<div class="col-xl-4 col-lg-6 col-md-12 padding-bottom">
					<ngb-accordion #acc="ngbAccordion" (panelChange)="onAccordionClick($event)" [activeIds]="expandIds">
						<ngb-panel title="{{ 'adminstat.filterForm.refererType' | translate }}" [id]="'source'">
							<ng-template ngbPanelContent>
								<form class="form-horizontal">
									<div class="form-group text-center">
										<button
											type="button"
											(click)="changeRefererType('simple')"
											[class]="filter.filterParams.refererFilterType == 'simple' ? 'btn btn-light active' : 'btn btn-light'"
										>
											{{ 'adminstat.filterForm.simple' | translate }}
										</button>
										
										<button
											type="button"
											(click)="changeRefererType('extended')"
											[class]="filter.filterParams.refererFilterType == 'extended' ? 'btn btn-light active' : 'btn btn-light'"
										>
											{{ 'adminstat.filterForm.extended' | translate }}
										</button>
									</div>
	
									<hr>
	
									<!--SIMPLE-->
									<ng-container
										*ngIf="filter.filterParams.refererFilterType == 'simple'"
									>
										<div class="form-group">
											<div class="row">
												<h6 class="col-xl-6 col-lg-12 control-label">
													{{ 'adminstat.filterForm.refererType' | translate }}
												</h6>
												
												<div class="col-xl-6 col-lg-12">
													<select
														class="form-control"
														[(ngModel)]="filter.filterParams.refererType"
														[ngModelOptions]="{standalone: true}"
														[sextant]="'filter-refererType'"
													>
														<option
															*ngFor="let opt of ['first', 'created', 'last', 'paid']"
															value="{{ opt }}"
															[selected]="opt == filter.filterParams.refererType"
														>
															{{ 'adminstat.filterForm.' + opt | translate }}
														</option>
													</select>
												</div>
											</div>
										</div>
									
										<div class="form-group">
											<div class="row">
												<h6 class="col-xl-6 col-lg-12 control-label">
													{{ 'adminstat.filterForm.refGroup' | translate }}
												</h6>
												
												<div class="col-xl-6 col-lg-12">
													<select
														class="form-control"
														[(ngModel)]="filter.filterParams.refGroup"
														[ngModelOptions]="{standalone: true}"
														[sextant]="'filter-refGroup'"
														(change)="onRefGroupSelect($event.target.value)"
													>
														<option
															*ngFor="let opt of refGroupList"
															value="{{ opt }}"
															[selected]="opt == filter.filterParams.refGroup"
														>
															{{ opt }}
														</option>
													</select>
												</div>
											</div>
										</div>
		
										<div class="form-group">
											<div class="row">
												<h6 class="col-xl-6 col-lg-12 control-label">{{ 'adminstat.filterForm.refSource' | translate }}</h6>
												<div class="col-xl-6 col-lg-12">
													<select class="form-control" [(ngModel)]="filter.filterParams.refSource" [ngModelOptions]="{standalone: true}" [sextant]="'filter-refSource'">
														<option *ngFor="let opt of ['all'].concat(refSourceList)"
																value="{{ opt }}" [selected]="opt == filter.filterParams.refSource">{{ opt }}
														</option>
													</select>
												</div>
											</div>
										</div>
	
										<div class="form-group">
											<div class="row">
												<h6 class="col-xl-6 col-lg-12 control-label">URL</h6>
												<div class="col-xl-6 col-lg-12">
													<input class="form-control" [(ngModel)]="filter.filterParams.refUrl" [ngModelOptions]="{standalone: true}">
												</div>
											</div>
										</div>
									</ng-container>
	
									<!--EXTENDED-->
									<div
										*ngIf="filter.filterParams.refererFilterType == 'extended'"
									>
										<div
											*ngFor="let f of filter.filterParams.refExtendedFilters; let i = index"
										>
											<input
												*ngIf="f.condition"
												type="hidden"
												[(ngModel)]="f.condition"
												[ngModelOptions]="{standalone: true}"
											>
	
											<b *ngIf="f.condition">
												{{ 'adminstat.filterForm.' + f.condition | translate }}
											</b>

											<ng-container *ngIf="f.condition == 'or'">
												<br><br>
											</ng-container>
											
											<hr *ngIf="f.condition == 'and'">
	
											<div class="form-group" *ngIf="!f.condition">
												<div class="row">
													<h6 class="col-xl-6 col-lg-12 control-label">
														{{ 'adminstat.filterForm.refererType' | translate }}
													</h6>
													
													<div class="col-xl-6 col-lg-12">
														<select
															class="form-control"
															[(ngModel)]="f.refererType"
															[ngModelOptions]="{standalone: true}"
														>
															<option
																*ngFor="let opt of refererTypes"
																value="{{ opt }}"
																[selected]="opt == f.refererType"
															>
																{{ 'adminstat.filterForm.' + opt | translate }}
															</option>
														</select>
													</div>
												</div>
											</div>
	
											<div class="form-group" *ngIf="!f.condition">
												<div class="row">
													<h6 class="col-xl-6 col-lg-12 control-label">
														{{ 'adminstat.filterForm.option' | translate }}
													</h6>
													
													<div class="col-xl-6 col-lg-12">
														<select
															class="form-control"
															[(ngModel)]="f.searchByMarkUtm"
															[ngModelOptions]="{standalone: true}"
														>
															<option
																*ngFor="let opt of helper.getUtmList().concat(['referal'])"
																value="{{ opt }}"
																[selected]="opt == f.searchByMarkUtm"
															>
																{{ opt }}
															</option>
														</select>
													</div>
												</div>
											</div>
	
											<div class="form-group" *ngIf="!f.condition">
												<div class="row">
													<h6 class="col-xl-6 col-lg-12 control-label">
														{{ 'adminstat.filterForm.match type' | translate }}
													</h6>
													
													<div class="col-xl-6 col-lg-12">
														<select class="form-control" [(ngModel)]="f.searchByMarkRule" [ngModelOptions]="{standalone: true}">
															<option
																*ngFor="let opt of refExtendedFilterOperators"
																value="{{ opt }}"
																[selected]="opt == f.searchByMarkRule"
															>
																{{ 'adminstat.users.group_ref_new.' + opt | translate }}
															</option>
														</select>
													</div>
												</div>
											</div>
	
											<div class="form-group" *ngIf="!f.condition">
												<div class="row">
													<h6 class="col-xl-6 col-lg-12 control-label">
														{{ 'adminstat.filterForm.value' | translate }}
													</h6>
													
													<div class="col-xl-6 col-lg-12">
														<input
															class="form-control"
															[(ngModel)]="f.refererSearchValue"
															[ngModelOptions]="{standalone: true}"
															[attr.index]="i"
														/>
													</div>
												</div>
											</div>
										</div>
	
										<br>
	
										<div class="btn-group" style="float:right;">
											<button type="button" class="btn btn-secondary" (click)="refMinus()">
												<i class="fa fa-times" aria-hidden="true"></i>
											</button>
	
											<button type="button" class="btn btn-secondary" (click)="refPlus('or')">
												{{ 'adminstat.filterForm.or' | translate }}
											</button>
	
											<button type="button" class="btn btn-secondary" (click)="refPlus('and')">
												{{ 'adminstat.filterForm.and' | translate }}
											</button>
										</div>
									</div>
								</form>
							</ng-template>
						</ngb-panel>
					</ngb-accordion>
				</div>
				
				<!--PAYMENTS FILTERS-->
				<div class="col-xl-4 col-lg-6 col-md-12 padding-bottom">
					<ngb-accordion #acc="ngbAccordion" (panelChange)="onAccordionClick($event)" [activeIds]="expandIds">
						<ngb-panel title="{{ 'adminstat.filterForm.payments' | translate }}" [id]="'processor-type'">
							<ng-template ngbPanelContent>
								<form class="form-horizontal">
									
									<!--«Платность»-->
									<div class="form-group">
										<div class="row">
											<h6 class="col-xl-6 col-lg-12 control-label">
												Платность
											</h6>
											
											<div class="col-xl-6 col-lg-12">
												<ng-selectize
													[sextant]="'filter-paidStatus'"
													[config]="paidStatusSelectize.config"
													[options] = "paidStatusSelectize.options"
													[(ngModel)]="filter.filterParams.paidStatus"
													[ngModelOptions]="{standalone: true}"
												>
												</ng-selectize>
											</div>
											
											<div
												class="col-xl-12 col-lg-12"
											     *ngIf="filter.filterParams.paidStatus === 'trial' || ( filter.filterParams.paidStatus && filter.filterParams.paidStatus.includes && filter.filterParams.paidStatus.includes('trial') )"
											>
												<table class="table">
													<tbody>
													<tr>
														<td>
															{{ 'adminstat.filterForm.trial day' | translate }}
														</td>
														
														<td>
															{{ 'adminstat.filterForm.start' | translate }}
															
															<input
																type="text"
																class="form-control"
																placeholder="0"
																[(ngModel)]="filter.filterParams.trialStart" [ngModelOptions]="{standalone: true}"
																[value]="filter.filterParams.trialStart">
														</td>
														
														<td>
															{{ 'adminstat.filterForm.end' | translate }}
															
															<input
																type="text"
																class="form-control"
																placeholder="14"
																[(ngModel)]="filter.filterParams.trialEnd" [ngModelOptions]="{standalone: true}"
																[value]="filter.filterParams.trialEnd">
														</td>
													</tr>
													</tbody>
												</table>
											</div>
										</div>
									</div>
									
									<!-- «Платежная модель» -->
									<div class="form-group">
										<div class="row">
											<h6 class="col-xl-6 col-lg-12 control-label">Платежная модель</h6>
											<div class="col-xl-6 col-lg-12">
												<select class="form-control" [(ngModel)]="filter.filterParams.paidMode" [ngModelOptions]="{standalone: true}" [sextant]="'filter-paidMode'">
													<option *ngFor="let opt of ['', 'premium', 'freemium', 'promo', 'municipal']"
													        value="{{ opt }}" [selected]="opt === filter.filterParams.paidMode">{{ 'adminstat.filterForm.' + opt | translate }}
													</option>
												</select>
											</div>
										</div>
									</div>
									
									<!--processorType-->
									<div class="form-group">
										<div class="row">
											<h6 class="col-xl-6 col-lg-12 control-label">{{ 'adminstat.filterForm.processorType' | translate }}</h6>
											<div class="col-xl-6 col-lg-12">
												<select class="form-control" [(ngModel)]="filter.filterParams.processorType" [ngModelOptions]="{standalone: true}" [sextant]="'filter-processorType'">
													<option *ngFor="let opt of ['all', 'noCashless'].concat(processorList)"
															value="{{ opt }}" [selected]="opt == filter.filterParams.processorType">{{ 'adminstat.filterForm.' + opt | translate }}
													</option>
												</select>
											</div>
										</div>
									</div>
									
									
									<div class="form-group" *ngIf="filter.filterParams.processorType == 'paymentwall'">
										<div class="row">
											<h6 class="col-xl-6 col-lg-12 control-label">{{ 'adminstat.filterForm.paymentwallMethod' | translate }}</h6>
											<div class="col-xl-6 col-lg-12">
												<select class="form-control" [(ngModel)]="filter.filterParams.paymentwallMethod" [ngModelOptions]="{standalone: true}" [sextant]="'filter-paymentwallMethod'">
													<option *ngFor="let opt of ['all', 'pagseguro', 'boletobancario']"
															value="{{ opt }}" [selected]="opt == filter.filterParams.paymentwallMethod">{{ opt }}
													</option>
												</select>
											</div>
										</div>
									</div>
									
									<!--currency-->
									<div class="form-group">
										<div class="row">
											<h6 class="col-xl-6 col-lg-12 control-label">{{ 'adminstat.filterForm.currency' | translate }}</h6>
											<div class="col-xl-6 col-lg-12">
												<select class="form-control" [(ngModel)]="filter.filterParams.currency" [ngModelOptions]="{standalone: true}" [sextant]="'filter-currency'">
													<option *ngFor="let opt of ['all'].concat(currencyList)"
															value="{{ opt }}" [selected]="opt == filter.filterParams.currency">{{ 'adminstat.filterForm.' + opt | translate }}
													</option>
												</select>
											</div>
										</div>
									</div>
									
									<!--userCurrency-->
									<div class="form-group">
										<div class="row">
											<h6 class="col-xl-6 col-lg-12 control-label">{{ 'adminstat.filterForm.userCurrency' | translate }}</h6>
											<div class="col-xl-6 col-lg-12">
												<select class="form-control" [(ngModel)]="filter.filterParams.userCurrency" [ngModelOptions]="{standalone: true}" [sextant]="'filter-userCurrency'">
													<option *ngFor="let opt of ['all'].concat(currencyList)"
															value="{{ opt }}" [selected]="opt == filter.filterParams.userCurrency">{{ 'adminstat.filterForm.' + opt | translate }}
													</option>
												</select>
											</div>
										</div>
									</div>
									
									<!--paidType-->
									<div class="form-group">
										<div class="row">
											<h6 class="col-xl-6 col-lg-12 control-label">
												{{ 'adminstat.filterForm.paidType' | translate }}
											</h6>
											
											<div class="col-xl-6 col-lg-12">
												<select
													class="form-control"
													[(ngModel)]="filter.filterParams.paidType"
													[ngModelOptions]="{standalone: true}"
													[sextant]="'filter-paidType'"
												>
													<option
														*ngFor="let opt of ['all', 'noUber', 'firstManual', 'secondManual', 'firstRecurrent', 'secondRecurrent', 'uber', 'upgrade', 'promopult', 'oneclick']"
														value="{{ opt }}"
														[selected]="opt == filter.filterParams.paidType"
													>
														{{ 'adminstat.filterForm.' + opt | translate }}
													</option>
												</select>
											</div>
										</div>
									</div>
	
									<!--tariffVariant-->
									<div class="form-group">
										<div class="row">
											<h6 class="col-xl-6 col-lg-12 control-label">{{ 'adminstat.filterForm.tariffVariant' | translate }}</h6>
											<div class="col-xl-6 col-lg-12">
												<select class="form-control" [(ngModel)]="filter.filterParams.tariffVariant" [ngModelOptions]="{standalone: true}" [sextant]="'filter-tariffVariant'">
													<option *ngFor="let opt of ['all'].concat(tariffVariantList, 'no24months')"
															value="{{ opt }}" [selected]="opt == filter.filterParams.tariffVariant">
														{{ 'adminstat.filterForm.' + (tariffVariantList.includes(opt) ? 'tariffVariants.' + opt : opt) | translate }}
													</option>
												</select>
											</div>
										</div>
									</div>
	
									<!--tariffId-->
									<div class="form-group">
										<div class="row">
											<h6 class="col-xl-6 col-lg-12 control-label">
												{{ 'adminstat.filterForm.tariffId' | translate }}
											</h6>
											
											<div class="col-xl-6 col-lg-12">
												<select
													class="form-control"
													[(ngModel)]="filter.filterParams.tariffId"
													[ngModelOptions]="{standalone: true}"
													[sextant]="'filter-tariffId'"
												>
													<option
														*ngFor="let opt of ['all', 'notAuction'].concat(tariffIdList)"
														value="{{ opt }}"
														[selected]="opt == filter.filterParams.tariffId"
													>
														{{ 'adminstat.filterForm.' + opt | translate }}
													</option>
												</select>
												
												<table
													*ngIf="filter.filterParams.tariffId == 'upgrade'"
												>
													<tr>
														<td>
															{{ 'adminstat.common.from' | translate }}
														</td>
														
														<td>
															<select
																class="form-control"
																[(ngModel)]="filter.filterParams.tariffMigrationFrom"
																[ngModelOptions]="{standalone: true}"
															>
																<option
																	*ngFor="let opt of ['all'].concat(tariffIdList)"
																	value="{{ opt }}"
																	[selected]="opt == filter.filterParams.tariffMigrationFrom"
																>
																	{{ 'adminstat.filterForm.' + opt | translate }}
																</option>
															</select>
														</td>
													</tr>
													
													<tr>
														<td>
															{{ 'adminstat.common.to' | translate }}
														</td>
														
														<td>
															<select
																class="form-control"
																[(ngModel)]="filter.filterParams.tariffMigrationTo"
																[ngModelOptions]="{standalone: true}"
															>
																<option
																	*ngFor="let opt of ['all'].concat(tariffIdList)"
																	value="{{ opt }}"
																	[selected]="opt == filter.filterParams.tariffMigrationTo"
																>
																	{{ 'adminstat.filterForm.' + opt | translate }}
																</option>
															</select>
														</td>
													</tr>
												</table>
											</div>
										</div>
									</div>
	
									<!--uberSite-->
									<div class="form-group">
										<div class="row">
											<h6 class="col-xl-6 col-lg-12 control-label">{{ 'adminstat.filterForm.uberSite' | translate }}</h6>
											<div class="col-xl-6 col-lg-12">
												<select class="form-control" [(ngModel)]="filter.filterParams.uberSite" [ngModelOptions]="{standalone: true}" [sextant]="'filter-uberSite'">
													<option *ngFor="let opt of ['all', 'no', 'yes']"
															value="{{ opt }}" [selected]="opt == filter.filterParams.uberSite">
														{{ 'adminstat.filterForm.' + opt | translate }}
													</option>
												</select>
											</div>
										</div>
									</div>
	
									<!--isSeoUber-->
									<div class="form-group">
										<div class="row">
											<h6 class="col-xl-6 col-lg-12 control-label">{{ 'adminstat.filterForm.isSeoUber' | translate }}</h6>
											<div class="col-xl-6 col-lg-12">
												<select class="form-control" [(ngModel)]="filter.filterParams.isSeoUber" [ngModelOptions]="{standalone: true}" [sextant]="'filter-isSeoUber'">
													<option *ngFor="let opt of ['', 'no', 'yes']"
															value="{{ opt }}" [selected]="opt == filter.filterParams.isSeoUber">
														{{ 'adminstat.filterForm.' + opt | translate }}
													</option>
												</select>
											</div>
										</div>
									</div>

									<!--isOneClick-->
									<div class="form-group">
										<div class="row">
											<h6 class="col-xl-6 col-lg-12 control-label">{{ 'adminstat.filterForm.isOneClick' | translate }}</h6>
											<div class="col-xl-6 col-lg-12">
												<select class="form-control" [(ngModel)]="filter.filterParams.isOneClick" [ngModelOptions]="{standalone: true}" [sextant]="'filter-isOneClick'">
													<option *ngFor="let opt of ['', 'no', 'yes']"
															value="{{ opt }}" [selected]="opt == filter.filterParams.isOneClick">
														{{ 'adminstat.filterForm.' + opt | translate }}
													</option>
												</select>
											</div>
										</div>
									</div>
									
									<div class="form-group">
										<div class="row">
											<h6 class="col-xl-6 col-lg-12 control-label">{{ 'adminstat.filterForm.promopultPaidType' | translate }}</h6>
											<div class="col-xl-6 col-lg-12">
												<select
													class="form-control"
												    [(ngModel)]="filter.filterParams.promopultPaidType"
													[ngModelOptions]="{standalone: true}"
													[sextant]="'filter-promopultPaidType'"
												>
													<option
														*ngFor="let opt of ['', 'noPaid', 'onePaid', 'moreOnePaid']"
														value="{{ opt }}"
														[selected]="opt == filter.filterParams.promopultPaidType"
													>
														{{ 'adminstat.filterForm.' + opt | translate }}
													</option>
												</select>
											</div>
										</div>
									</div>
	
									<!--user21billing-->
									<div class="form-group">
										<div class="row">
											<h6 class="col-xl-6 col-lg-12 control-label">{{ 'adminstat.filterForm.user21billing' | translate }}</h6>
											<div class="col-xl-6 col-lg-12">
												<select class="form-control" [(ngModel)]="filter.filterParams.user21billing" [ngModelOptions]="{standalone: true}" [sextant]="'filter-user21billing'">
													<option *ngFor="let opt of ['', '7days', '14days', '21days', 'gt21days', 'between']"
															value="{{ opt }}" [selected]="opt == filter.filterParams.user21billing">
														{{ 'adminstat.filterForm.' + opt | translate }}
													</option>
												</select>
												<div *ngIf="filter.filterParams.user21billing == 'between'">
													<input type="text" class="form-control" placeholder="from" value="{{ filter.filterParams.user21billingStart }}" [(ngModel)]="filter.filterParams.user21billingStart" [ngModelOptions]="{standalone: true}">
													<input type="text" class="form-control" placeholder="to" value="{{ filter.filterParams.user21billingEnd }}" [(ngModel)]="filter.filterParams.user21billingEnd" [ngModelOptions]="{standalone: true}">
												</div>
											</div>
										</div>
									</div>

									<!--card_expiry-->
									<div class="form-group">
										<div class="row">
											<h6 class="col-xl-6 col-lg-12 control-label">CC Month/Year</h6>
											<div class="col-xl-6 col-lg-12">
												<input type="text" class="form-control" placeholder="MM/YYYY" value="{{ filter.filterParams.cardExpiry }}" [(ngModel)]="filter.filterParams.cardExpiry" [ngModelOptions]="{standalone: true}">
											</div>
										</div>
									</div>

								</form>
							</ng-template>
						</ngb-panel>
					</ngb-accordion>
				</div>
				
				<!--SITES FILTERS-->
				<div class="col-xl-4 col-lg-6 col-md-12 padding-bottom">
					<ngb-accordion #acc="ngbAccordion" (panelChange)="onAccordionClick($event)" [activeIds]="expandIds">
						<ngb-panel title="{{ 'adminstat.common.sites' | translate }}" [id]="'siteFilter'">
							<ng-template ngbPanelContent>
								<form class="form-horizontal">
									
									<!--sitesFilter-->
									<div class="row">
										<div class="col-md-12">
											<div class="radio">
												<label>
													<input type="radio" [(ngModel)]="filter.filterParams.sitesFilter" [ngModelOptions]="{standalone: true}" value="all" [checked]="filter.filterParams.sitesFilter == 'all'">
													{{ 'adminstat.filterForm.all' | translate }}
												</label>
											</div>
										</div>
										<div class="col-md-12">
											<div class="radio">
												<label>
													<input type="radio" [(ngModel)]="filter.filterParams.sitesFilter" [ngModelOptions]="{standalone: true}" value="without" [checked]="filter.filterParams.sitesFilter == 'without'">
													{{ 'adminstat.filterForm.without' | translate }}
												</label>
											</div>
										</div>
										<div class="col-md-12">
											<div class="radio">
												<label>
													<input type="radio" [(ngModel)]="filter.filterParams.sitesFilter" [ngModelOptions]="{standalone: true}" value="with" [checked]="filter.filterParams.sitesFilter == 'with'">
													{{ 'adminstat.filterForm.with' | translate }}
												</label>
											</div>
											
											<div class="col-md-offset-2" *ngIf="filter.filterParams.sitesFilter == 'with'">
												<fieldset>
													<label>{{ 'adminstat.common.Site' | translate }}</label>
													<input class="form-control" type="text" [(ngModel)]="filter.filterParams.siteUrl" [ngModelOptions]="{standalone: true}" value="{{ filter.filterParams.siteUrl }}">
													
													<div class="checkbox">
														<label>
															<input type="checkbox" [(ngModel)]="filter.filterParams.isPublished" [ngModelOptions]="{standalone: true}" value="true" [checked]="filter.filterParams.isPublished">
															{{ 'adminstat.filterForm.isPublished' | translate }}
														</label>
													</div>
													<div class="checkbox">
														<label>
															<input type="checkbox" [(ngModel)]="filter.filterParams.isNotPublished" [ngModelOptions]="{standalone: true}" value="true" [checked]="filter.filterParams.isNotPublished">
															{{ 'adminstat.filterForm.isNotPublished' | translate }}
														</label>
													</div>
													<div class="checkbox">
														<label>
															<input type="checkbox" [(ngModel)]="filter.filterParams.isNotCompleted" [ngModelOptions]="{standalone: true}" value="true" [checked]="filter.filterParams.isNotCompleted">
															{{ 'adminstat.filterForm.isNotCompleted' | translate }}
														</label>
													</div>
													<div class="checkbox">
														<label>
															<input type="checkbox" [(ngModel)]="filter.filterParams.withDomain" [ngModelOptions]="{standalone: true}" value="true" [checked]="filter.filterParams.withDomain">
															{{ 'adminstat.filterForm.hasDomain' | translate }}
														</label>
													</div>
													<div class="checkbox">
														<label>
															<input type="checkbox" [(ngModel)]="filter.filterParams.withoutDomain" [ngModelOptions]="{standalone: true}" value="true" [checked]="filter.filterParams.withoutDomain">
															{{ 'adminstat.filterForm.withoutDomain' | translate }}
														</label>
													</div>
													<div class="checkbox">
														<label>
															<input type="checkbox" [(ngModel)]="filter.filterParams.hasProductCard" [ngModelOptions]="{standalone: true}" value="true" [checked]="filter.filterParams.hasProductCard">
															{{ 'adminstat.filterForm.hasProductCard' | translate }}
														</label>
													</div>
													
													<div class="checkbox">
														<label>
															<input type="checkbox" [(ngModel)]="filter.filterParams.isPaidType" [ngModelOptions]="{standalone: true}" value="true" [checked]="filter.filterParams.isPaidType">
															{{ 'adminstat.filterForm.isPaidType' | translate }}
														</label>
													</div>
													
													<div class="checkbox">
														<label>
															<input type="checkbox" [(ngModel)]="filter.filterParams.isBan" [ngModelOptions]="{standalone: true}" value="true" [checked]="filter.filterParams.isBan">
															{{ 'adminstat.support.accessor.isBan' | translate }}
														</label>
													</div>
													
													
													<label>{{ 'adminstat.filterForm.domainZone' | translate }}</label>
													<input class="form-control" type="text" [(ngModel)]="filter.filterParams.domainZone" [ngModelOptions]="{standalone: true}" value="{{ filter.filterParams.domainZone }}">
												</fieldset>
											</div>
										</div>
									</div>
									
									<hr/>
									
									<div class="row">
										<div class="col-md-12">
											<div class="form-group">
												<label>
													{{ 'adminstat.mails.mailer.has widget' | translate }}
												</label>
												<ng-selectize
													[config]="selectizeWidget.config"
													[options] = "selectizeWidget.options"
													[(ngModel)]="filter.filterParams.widgetList"
													[ngModelOptions]="{standalone: true}"
												>
												</ng-selectize>
											</div>
										</div>
										
										<div class="col-md-12">
											<div class="form-group">
												<label>
													{{ 'adminstat.mails.mailer.has badge' | translate }}
												</label>
												<ng-selectize
													[config]="selectizeBadges.config"
													[options] = "selectizeBadges.options"
													[(ngModel)]="filter.filterParams.badgesList"
													[ngModelOptions]="{standalone: true}"
												>
												</ng-selectize>
											</div>
										</div>
									</div>
									
									<hr/>
									
									<div class="row">
										<div class="col-md-12">
											<div class="form-group">
												<div class="checkbox">
													<label>
														<input
															type="checkbox"
															[(ngModel)]="filter.filterParams.isExcludeUserAndSite"
															[ngModelOptions]="{standalone: true}"
															value="false"
															[checked]="filter.filterParams.isExcludeUserAndSite"
														>
														{{ 'adminstat.filterForm.isExcludeUserAndSite' | translate }}
													</label>
												</div>
											</div>
										</div>
									</div>
									
									<div class="row">
										<div class="col-md-12">
											<div class="form-group">
												<div class="checkbox">
													<label>
														<input
															type="checkbox"
															[(ngModel)]="filter.filterParams.isExcludeArbitrage"
															[ngModelOptions]="{standalone: true}"
															value="false"
															[checked]="filter.filterParams.isExcludeArbitrage"
														>
														Исключить арбитражников
													</label>
												</div>
											</div>
										</div>
									</div>
									
									<hr/>
									
									<!--subjects and categories-->
									<div class="row">
										<div class="col-md-12">
											<div class="form-group">
												<label>
													{{ 'adminstat.common.Subject template' | translate }}
												</label>
												
												<ng-selectize
													[config]="selectizeSubject.config"
													[options] = "selectizeSubject.options"
													[(ngModel)]="filter.filterParams.subject"
													[ngModelOptions]="{standalone: true}"
												>
												</ng-selectize>
											</div>
										</div>
									</div>
									
									<div class="row">
										<div class="col-md-12">
											<div class="form-group">
												<label>
													{{ 'adminstat.common.templateId' | translate }}
												</label>
												<ng-selectize
													[config]="selectizeTemplate.config"
													[options] = "selectizeTemplate.options"
													[(ngModel)]="filter.filterParams.templateId"
													[ngModelOptions]="{standalone: true}"
												>
												</ng-selectize>
											</div>
										</div>
									</div>
									
									<hr/>

									<div class="row">
										<div class="col-md-12">
											<div class="form-group">
												<label>
													{{ 'adminstat.common.templateName' | translate }}
												</label>
												<input 
														type="text"
														class="form-control"
														value="{{ filter.filterParams.templateName }}"
														[(ngModel)]="filter.filterParams.templateName"
														[ngModelOptions]="{standalone: true}"
												>
											</div>
										</div>
									</div>

									<hr/>
									
									<!-- category -->
									<div class="row">
										<div class="col-md-12">
											<div class="form-group">
												<label>
													{{ 'adminstat.filterForm.category' | translate }}
												</label>
												&nbsp;&nbsp;
												<input type="radio" [(ngModel)]="filter.filterParams.categoryMembership" [ngModelOptions]="{standalone: true}" value="in" [checked]="filter.filterParams.categoryMembership == 'in'">
												&#8712;
												<input type="radio" [(ngModel)]="filter.filterParams.categoryMembership" [ngModelOptions]="{standalone: true}" value="notIn" [checked]="filter.filterParams.categoryMembership == 'notIn'">
												&#8713;

												<select class="form-control" [(ngModel)]="filter.filterParams.category" [ngModelOptions]="{standalone: true}">
													<option *ngFor="let opt of ['all'].concat(siteCategories)"
													        value="{{ opt }}" [selected]="opt == filter.filterParams.category">
														{{ opt }}
													</option>
												</select>
											</div>
										</div>
									</div>
									
									<!-- realSubject -->
									<div class="row" *ngIf="filter.filterParams.category && filter.filterParams.category !== 'all'">
										<div class="col-md-12">
											<div class="form-group">
												<label>
													{{ 'adminstat.filterForm.realSubject' | translate }}
												</label>
												<select class="form-control" [(ngModel)]="filter.filterParams.realSubject" [ngModelOptions]="{standalone: true}">
													<option *ngFor="let opt of [''].concat(getSubjectsByCategory(filter.filterParams.category))"
													        value="{{ opt }}" [selected]="opt == filter.filterParams.realSubject">
														{{ opt }}
													</option>
												</select>
											</div>
										</div>
									</div>
									
									<hr/>
									
									<!--serverAlias-->
									<div class="row">
										<div class="col-md-12">
											<div class="form-group">
												<label>
													{{ 'adminstat.filterForm.serverAlias' | translate }}
												</label>
												<select class="form-control" [(ngModel)]="filter.filterParams.serverAlias" [ngModelOptions]="{standalone: true}">
													<option *ngFor="let opt of ['all'].concat(serverAliasList)"
													        value="{{ opt }}" [selected]="opt == filter.filterParams.serverAlias">
														{{ opt }}
													</option>
												</select>
											</div>
										</div>
									</div>
									
									<div class="row">
										<div class="col-md-12">
											<div class="form-group">
												<label>
													{{ 'adminstat.filterForm.serverZone' | translate }}
												</label>
												<select class="form-control" [(ngModel)]="filter.filterParams.serverZone" [ngModelOptions]="{standalone: true}">
													<option *ngFor="let opt of [''].concat(serverZoneList)"
													        value="{{ opt }}" [selected]="opt == filter.filterParams.serverZone">
														{{ opt }}
													</option>
												</select>
											</div>
										</div>
									</div>
									
									<hr/>
									
									<div class="row">
										<div class="col-md-12">
											<h5>{{ 'adminstat.filterForm.liveliness' | translate }}</h5>
										</div>
									</div>
									
									<!--lastLogin-->
									<div class="row">
										<div class="col-md-12">
											<div class="form-group">
												<label>
													{{ 'adminstat.filterForm.lastLogin' | translate }}
												</label>
												<input
														type="text"
														class="form-control"
														placeholder="dd/mm/YYY"
														[(ngModel)]="filter.filterParams.lastLogin" [ngModelOptions]="{standalone: true}"
														[value]="filter.filterParams.lastLogin ? moment(filter.filterParams.lastLogin).format('DD-MM-YYYY') : ''"
												>
											</div>
										</div>
									</div>
									
									<div class="row">
										<!--greatLoginTime-->
										<div class="col-md-12">
											<div class="form-group">
												<label>
													{{ 'adminstat.filterForm.greatLoginTime' | translate }} (>)
												</label>
												<select class="form-control" [(ngModel)]="filter.filterParams.greatLoginTime" [ngModelOptions]="{standalone: true}">
													<option *ngFor="let opt of ['all', '1','2','3','4','5','6','7','8','9','10','11','12','13','14','15','16','17','18','19']"
															value="{{ opt }}" [selected]="opt == filter.filterParams.greatLoginTime">
														{{ opt }}
													</option>
												</select>
											</div>
										</div>
									</div>
									
									<hr/>
									
									<!--addedWidget-->
									<div class="row">
										<div class="col-md-12">
											<div class="form-group">
												<label>
													{{ 'adminstat.filterForm.addedWidget' | translate }}
												</label>
											</div>
											
											<div class="form-group row">
												<label class="col-sm-2 col-form-label">
													{{ 'adminstat.common.from' | translate }}
												</label>
												<div class="col-sm-10">
													<input
														type="text"
														class="form-control"
														placeholder="0"
														[(ngModel)]="filter.filterParams.addedWidget.gt" [ngModelOptions]="{standalone: true}"
														[value]="filter.filterParams.addedWidget && filter.filterParams.addedWidget.gt ? filter.filterParams.addedWidget.gt : ''">
												</div>
											</div>
											<div class="form-group row">
												<label class="col-sm-2 col-form-label">
													{{ 'adminstat.common.to' | translate }}
												</label>
												<div class="col-sm-10">
													<input
														type="text"
														class="form-control"
														placeholder="&#8734;"
														[(ngModel)]="filter.filterParams.addedWidget.lt" [ngModelOptions]="{standalone: true}"
														[value]="filter.filterParams.addedWidget && filter.filterParams.addedWidget.lt ? filter.filterParams.addedWidget.lt : ''">
												</div>
											</div>
										</div>
									</div>
									
									<hr/>
									
									<div class="row">
										<!--actionCount-->
										<div class="col-md-12">
											<div class="form-group">
												<label>
													{{ 'adminstat.filterForm.actionCount' | translate }}
												</label>
											</div>
											
											<div class="form-group row">
												<label class="col-sm-2 col-form-label">
													{{ 'adminstat.common.from' | translate }}
												</label>
												<div class="col-sm-10">
													<input
														type="text"
														class="form-control"
														placeholder="0"
														[(ngModel)]="filter.filterParams.actionCount.gt" [ngModelOptions]="{standalone: true}"
														[value]="filter.filterParams.actionCount && filter.filterParams.actionCount.gt ? filter.filterParams.actionCount.gt : ''">
												</div>
											</div>
											<div class="form-group row">
												<label class="col-sm-2 col-form-label">
													{{ 'adminstat.common.to' | translate }}
												</label>
												<div class="col-sm-10">
													<input
														type="text"
														class="form-control"
														placeholder="&#8734;"
														[(ngModel)]="filter.filterParams.actionCount.lt" [ngModelOptions]="{standalone: true}"
														[value]="filter.filterParams.actionCount && filter.filterParams.actionCount.lt ? filter.filterParams.actionCount.lt : ''">
												</div>
											</div>
										</div>
									</div>
									
									<hr/>
									
									<div class="row">
										<!--promoProgress-->
										<div class="col-md-12">
											<div class="form-group">
												<label>
													promoProgress
												</label>
											</div>
											
											<div class="form-group row">
												<label class="col-sm-2 col-form-label">
													{{ 'adminstat.common.from' | translate }}
												</label>
												<div class="col-sm-10">
													<input
														type="text"
														class="form-control"
														placeholder="0"
														[(ngModel)]="filter.filterParams.promoProgress.gt" [ngModelOptions]="{standalone: true}"
														[value]="filter.filterParams.promoProgress && filter.filterParams.promoProgress.gt ? filter.filterParams.promoProgress.gt : ''">
												</div>
											</div>
											<div class="form-group row">
												<label class="col-sm-2 col-form-label">
													{{ 'adminstat.common.to' | translate }}
												</label>
												<div class="col-sm-10">
													<input
														type="text"
														class="form-control"
														placeholder="&#8734;"
														[(ngModel)]="filter.filterParams.promoProgress.lt" [ngModelOptions]="{standalone: true}"
														[value]="filter.filterParams.promoProgress && filter.filterParams.promoProgress.lt ? filter.filterParams.promoProgress.lt : ''">
												</div>
											</div>
										</div>
									</div>

									<hr/>

									<div class="row">
										<!--sitesNumber-->
										<div class="col-md-12">
											<div class="form-group">
												<label>
													{{ 'adminstat.filterForm.sitesNumber' | translate }}
												</label>
											</div>

											<div class="form-group row">
												<label class="col-sm-2 col-form-label">
													{{ 'adminstat.common.from' | translate }}
												</label>
												<div class="col-sm-10">
													<input
															type="text"
															class="form-control"
															placeholder="0"
															[(ngModel)]="filter.filterParams.sitesNumber.gt" [ngModelOptions]="{standalone: true}"
															[value]="filter.filterParams.sitesNumber && filter.filterParams.sitesNumber.gt ? filter.filterParams.sitesNumber.gt : ''">
												</div>
											</div>
											<div class="form-group row">
												<label class="col-sm-2 col-form-label">
													{{ 'adminstat.common.to' | translate }}
												</label>
												<div class="col-sm-10">
													<input
															type="text"
															class="form-control"
															placeholder="&#8734;"
															[(ngModel)]="filter.filterParams.sitesNumber.lt" [ngModelOptions]="{standalone: true}"
															[value]="filter.filterParams.sitesNumber && filter.filterParams.sitesNumber.lt ? filter.filterParams.sitesNumber.lt : ''">
												</div>
											</div>
										</div>
									</div>
								</form>
							</ng-template>
						</ngb-panel>
					</ngb-accordion>
				</div>
				
				<!--REG TYPE FILTERS-->
				<div class="col-xl-4 col-lg-6 col-md-12 padding-bottom">
					<ngb-accordion #acc="ngbAccordion" (panelChange)="onAccordionClick($event)" [activeIds]="expandIds">
						<ngb-panel title="{{ 'adminstat.filterForm.reg type filters' | translate }}" [id]="'sites'">
							<ng-template ngbPanelContent>
								
								<form class="form-horizontal">
									
									<!--userImportSource-->
									<div class="form-group">
										<div class="row">
											<h6 class="col-xl-6 col-lg-12 control-label">{{ 'adminstat.filterForm.userImportSource' | translate }}</h6>
											<div class="col-xl-6 col-lg-12">
												<select [(ngModel)]="filter.filterParams.userImportSource" [ngModelOptions]="{standalone: true}" class="form-control">
													<option *ngFor="let opt of ['', 'fromConvertor', 'fb-converter', 'vk-converter', 'alt-vk', 'regular-user']"
															value="{{ opt }}" [selected]="opt == filter.filterParams.userImportSource">
														{{ 'adminstat.filterForm.' + opt | translate }}
													</option>
												</select>
											</div>
										</div>
									</div>
									
									<!--regFilter-->
									<div class="form-group">
										<div class="row">
											<h6 class="col-xl-6 col-lg-12 control-label">{{ 'adminstat.filterForm.regFilter' | translate }}</h6>
											<div class="col-xl-6 col-lg-12">
												<select [(ngModel)]="filter.filterParams.regFilter" [ngModelOptions]="{standalone: true}" class="form-control">
													<option *ngFor="let opt of ['', 'email', 'quiz', 'sitebox'].concat(socialFilter)"
															value="{{ opt }}" [selected]="opt == filter.filterParams.regFilter">
														{{ opt }}
													</option>
												</select>
											</div>
										</div>
									</div>
									
									<!--isConfirm, isNotConfirm-->
									<div class="form-group" *ngIf="filter.filterParams.regFilter == 'email'">
										<div class="row">
											<h6 class="col-md-2 control-label"></h6>
											<div class="col-md-8">
												<div class="checkbox">
													<label>
														<input type="checkbox" [(ngModel)]="filter.filterParams.isConfirm" [ngModelOptions]="{standalone: true}" [checked]="filter.filterParams.isConfirm">
														{{ 'adminstat.filterForm.isConfirm' | translate }}
													</label>
												</div>
												
												<div class="checkbox">
													<label>
														<input type="checkbox" [(ngModel)]="filter.filterParams.isNotConfirm" [ngModelOptions]="{standalone: true}" [checked]="filter.filterParams.isNotConfirm">
														{{ 'adminstat.filterForm.isNotConfirm' | translate }}
													</label>
												</div>
											</div>
										</div>
									</div>
									
									<!--email, emailType, emailOther-->
									<div class="form-group" *ngIf="filter.filterParams.regFilter == 'email' || filter.filterParams.regFilter == ''">
										<h6 class="control-label">
											{{ 'adminstat.filterForm.email' | translate }}
										</h6>
										
										<div class="row">
											<div class="col-md-12 offset-md-2">
												<div class="radio">
													<label>
														<input
															[(ngModel)]="filter.filterParams.emailType"
															[ngModelOptions]="{standalone: true}"
															type="radio"
															value="list"
															[checked]="filter.filterParams.emailType == 'list'"
														>
														
														<select
															class="form-control"
															[(ngModel)]="filter.filterParams.email"
															[ngModelOptions]="{standalone: true}"
															[attr.radio]="'list'"
														>
															<option
																*ngFor="let opt of getEmailListWithGroups()"
																value="{{ opt }}"
																[selected]="opt == filter.filterParams.email"
															>
																{{ opt }}
															</option>
														</select>
													</label>
												</div>
												<div class="radio">
													<label>
														<input
															[(ngModel)]="filter.filterParams.emailType"
															[ngModelOptions]="{standalone: true}"
															type="radio"
															value="other"
															[checked]="filter.filterParams.emailType == 'other'"
														/>
														
														<input
															class="form-control"
															[(ngModel)]="filter.filterParams.emailOther"
															[ngModelOptions]="{standalone: true}"
															type="text">
													</label>
												</div>
											</div>
										</div>
									</div>
								</form>
							</ng-template>
						</ngb-panel>
					</ngb-accordion>
				</div>
				
				<!--DISPLAY SETTINGS-->
				<div class="col-xl-4 col-lg-6 col-md-12 padding-bottom" *ngIf="filter.filterParams.isBilling || filter.filterParams.isRegDay || filter.filterParams.isExpiredDomains || filter.filterParams.isNotice || filter.filterParams.isDomainBilling || filter.filterParams.isTemplateTag || filter.filterParams.isExpiredPaid">
					<ngb-accordion #acc="ngbAccordion" (panelChange)="onAccordionClick($event)" [activeIds]="expandIds">
						<ngb-panel title="{{ 'adminstat.filterForm.display settings' | translate }}" [id]="'settings'">
							<ng-template ngbPanelContent>
								<form class="form-horizontal">
									
									<!--isExpiredDomains - countForOther-->
									<div class="form-group" *ngIf="filter.filterParams.isExpiredDomains">
										<div class="row">
											<h6 class="col-xl-6 col-lg-12 control-label">{{ 'adminstat.filterForm.countForOther' | translate }}</h6>
											<div class="col-xl-6 col-lg-12">
												<input class="form-control" [(ngModel)]="filter.filterParams.countForOther" [ngModelOptions]="{standalone: true}">
											</div>
										</div>
									</div>
									
									<!--isNotice - noticeName-->
									<div class="form-group" *ngIf="filter.filterParams.isNotice">
										<div class="row">
											<h6 class="col-xl-6 col-lg-12 control-label">{{ 'adminstat.filterForm.noticeName' | translate }}</h6>
											<div class="col-xl-6 col-lg-12">
												<input class="form-control" [(ngModel)]="filter.filterParams.noticeName" [ngModelOptions]="{standalone: true}">
											</div>
										</div>
									</div>
									
									<!--isRegDay - isShowRegDayTotal-->
									<div class="form-group" *ngIf="filter.filterParams.isRegDay">
										<div class="row">
											<h6 class="col-xl-6 col-lg-12 control-label">{{ 'adminstat.filterForm.isShowRegDayTotal' | translate }}</h6>
											<div class="col-xl-6 col-lg-12">
												<div class="checkbox">
													<label>
														<input type="checkbox" [(ngModel)]="filter.filterParams.isShowRegDayTotal" [ngModelOptions]="{standalone: true}" [checked]="filter.filterParams.isShowRegDayTotal">
														{{ 'adminstat.filterForm.show' | translate }}
													</label>
												</div>
											</div>
										</div>
									</div>
									
									<!--isRegDay, isBilling - isShowReReg-->
									<div class="form-group" *ngIf="filter.filterParams.isRegDay || filter.filterParams.isBilling">
										<div class="row">
											<h6 class="col-xl-6 col-lg-12 control-label">{{ 'adminstat.filterForm.isShowReReg' | translate }}</h6>
											<div class="col-xl-6 col-lg-12">
												<div class="checkbox">
													<label>
														<input type="checkbox" [(ngModel)]="filter.filterParams.isShowReReg" [ngModelOptions]="{standalone: true}" [checked]="filter.filterParams.isShowReReg">
														{{ 'adminstat.filterForm.show' | translate }}
													</label>
												</div>
											</div>
										</div>
									</div>
									
									<!--isBilling - isShowBillingAdd-->
									<div class="form-group" *ngIf="filter.filterParams.isBilling">
										<div class="row">
											<h6 class="col-xl-6 col-lg-12 control-label">{{ 'adminstat.filterForm.isShowBillingAdd' | translate }}</h6>
											<div class="col-xl-6 col-lg-12">
												<div class="checkbox">
													<label>
														<input type="checkbox" [(ngModel)]="filter.filterParams.isShowBillingAdd" [ngModelOptions]="{standalone: true}" [checked]="filter.filterParams.isShowBillingAdd">
														{{ 'adminstat.filterForm.show' | translate }}
													</label>
												</div>
											</div>
										</div>
									</div>
									
									<!--isBilling - isShowBillingPeriod-->
									<div class="form-group" *ngIf="filter.filterParams.isBilling">
										<div class="row">
											<h6 class="col-xl-6 col-lg-12 control-label">{{ 'adminstat.filterForm.isShowBillingPeriod' | translate }}</h6>
											<div class="col-xl-6 col-lg-12">
												<div class="checkbox">
													<label>
														<input type="checkbox" [(ngModel)]="filter.filterParams.isShowBillingPeriod" [ngModelOptions]="{standalone: true}" [checked]="filter.filterParams.isShowBillingPeriod">
														{{ 'adminstat.filterForm.show' | translate }}
													</label>
												</div>
											</div>
										</div>
									</div>
									
									<!--isRegDay, isBilling - isShowSourceChange-->
									<div class="form-group" *ngIf="filter.filterParams.isRegDay || filter.filterParams.isBilling">
										<div class="row">
											<h6 class="col-xl-6 col-lg-12 control-label">
												{{ 'adminstat.users.reg_day.source changes' | translate }} ({{ 'adminstat.users.reg_day.short source changes' | translate }})
											</h6>
											<div class="col-md-6">
												<div class="checkbox">
													<label>
														<input type="checkbox" [(ngModel)]="filter.filterParams.isShowSourceChange" [ngModelOptions]="{standalone: true}" [checked]="filter.filterParams.isShowSourceChange">
														{{ 'adminstat.filterForm.show' | translate }}
													</label>
												</div>
											</div>
										</div>
									</div>
									
									<!--isRegDay, isBilling - isShowRelativeChange-->
									<div class="form-group" *ngIf="filter.filterParams.isRegDay || filter.filterParams.isBilling">
										<div class="row">
											<h6 class="col-xl-6 col-lg-12 control-label">
												{{ 'adminstat.users.reg_day.relative changes' | translate }} ({{ 'adminstat.users.reg_day.short relative changes' | translate }})
											</h6>
											<div class="col-xl-6 col-lg-12">
												<div class="checkbox">
													<label>
														<input type="checkbox" [(ngModel)]="filter.filterParams.isShowRelativeChange" [ngModelOptions]="{standalone: true}" [checked]="filter.filterParams.isShowRelativeChange">
														{{ 'adminstat.filterForm.show' | translate }}
													</label>
												</div>
											</div>
										</div>
									</div>
									
									<!--isTemplateTag-->
									<div class="form-group" *ngIf="filter.filterParams.isTemplateTag">
										<div class="row">
											<h6 class="col-xl-6 col-lg-12 control-label">{{ 'adminstat.filterForm.templateTagBorder' | translate }}</h6>
											<div class="col-xl-6 col-lg-12">
												<input class="form-control" [(ngModel)]="filter.filterParams.templateTagBorder" [ngModelOptions]="{standalone: true}">
											</div>
										</div>
									</div>
									
									<!--isExpiredPaid-->
									<div class="form-group" *ngIf="filter.filterParams.isExpiredPaid">
										<div class="row">
											<h6 class="col-xl-6 col-lg-12 control-label">{{ 'adminstat.filterForm.isShowExpiredPaidAddFields' | translate }}</h6>
											<div class="col-xl-6 col-lg-12">
												<div class="checkbox">
													<label>
														<input type="checkbox" [(ngModel)]="filter.filterParams.isShowExpiredPaidAddFields" [ngModelOptions]="{standalone: true}" [checked]="filter.filterParams.isShowExpiredPaidAddFields">
														{{ 'adminstat.filterForm.show' | translate }}
													</label>
												</div>
											</div>
										</div>
									</div>
								</form>
							</ng-template>
						</ngb-panel>
					</ngb-accordion>
				</div>
				
				<!--GEO FILTERS-->
				<div class="col-xl-4 col-lg-6 col-md-12 padding-bottom">
					<ngb-accordion #acc="ngbAccordion" (panelChange)="onAccordionClick($event)" [activeIds]="expandIds">
						<ngb-panel title="{{ 'adminstat.filterForm.GEO' | translate }}" [id]="'geo'">
							<ng-template ngbPanelContent>
								<form class="form-horizontal">
									
									<!--location-->
									<div class="form-group">
										<h6>{{ 'adminstat.filterForm.location by created' | translate }}</h6>
										
										<select class="form-control" [(ngModel)]="filter.filterParams.location" [ngModelOptions]="{standalone: true}" multiple="multiple">
											<option value="">{{ 'adminstat.common.any' | translate }}</option>
											<option *ngFor="let country of locations"
													value="{{ country.ccode }}" [selected]="country.ccode == filter.filterParams.location">
												{{ country.caption }}
											</option>
										</select>
									</div>
									
									<!--isShowCountry-->
									<div class="form-group" *ngIf="false">
										<div class="checkbox">
											<label>
												<input type="checkbox" [(ngModel)]="filter.filterParams.isShowCountry" [ngModelOptions]="{standalone: true}" [checked]="filter.filterParams.isShowCountry">
												{{ 'adminstat.filterForm.isShowCountry' | translate }}
											</label>
										</div>
									</div>
								</form>
							</ng-template>
						</ngb-panel>
					</ngb-accordion>
				</div>
				
				<!--EXPERIMENTS-->
				<div class="col-xl-4 col-lg-6 col-md-12 padding-bottom">
					<ngb-accordion #acc="ngbAccordion" (panelChange)="onAccordionClick($event)" [activeIds]="expandIds">
						<ngb-panel title="{{ 'adminstat.filterForm.experiments' | translate }}" [id]="'experiment'">
							<ng-template ngbPanelContent>
								<form class="form-horizontal">
								
									<!--experimentName-->
									<div class="form-group">
										<div class="row">
											<h6 class="col-xl-6 col-lg-12 control-label">{{ 'adminstat.filterForm.experiments' | translate }}</h6>
											<div class="col-xl-6 col-lg-12">
												<select class="form-control" [(ngModel)]="filter.filterParams.experimentName" [ngModelOptions]="{standalone: true}">
													<option *ngFor="let opt of  [
														'',
														'isFreemiunUser',
														'isFreemiun2User',
														'amountSplit',
														'regPath',
														'registrationSection',
														'tariffPageSplit',
														'isConvert',
														'flashPromo',
														'showNewTariffPage',
														'useReducedVariants',
														'randomFreemiun',
														'showTariffSelectionPage',
														'freemiumAndPremium',
														'summer2017',
														'newMainPage',
														'siteImportSplit',
														'newConverterSplit',
														'newMainPage2',
														'userDomainSplit',
														'wizardSplit',
														'ab12611'
														]" value="{{ opt }}" [selected]="opt == filter.filterParams.experimentName">
															{{ 'adminstat.filterForm.' + opt | translate }}
													</option>
												</select>
											</div>
										</div>
									</div>
									
									<div class="form-group">
										<div class="row">
											<h6 class="col-xl-6 col-lg-12 control-label">{{ 'adminstat.filterForm.option' | translate }}</h6>
											<div class="col-xl-6 col-lg-12">
												<select class="form-control" [(ngModel)]="filter.filterParams.experimentValue" [ngModelOptions]="{standalone: true}">
													<option *ngFor="let val of (filter.filterParams.experimentName != '' ? experimentMap[filter.filterParams.experimentName] : [])"
															value="{{ val }}" [selected]="val == filter.filterParams.experimentValue">
														{{ 'adminstat.filterForm.' + val | translate }}
													</option>
												</select>
											</div>
										</div>
									</div>
								</form>
							</ng-template>
						</ngb-panel>
					</ngb-accordion>
				</div>
				
				<div
					class="col-xl-4 col-lg-6 col-md-12 padding-bottom"
					*ngIf="filter.addFilters.includes('promocode')"
				>
					<ngb-accordion
						#acc="ngbAccordion"
						(panelChange)="onAccordionClick($event)"
						[activeIds]="expandIds"
					>
						<ngb-panel
							title="{{ 'adminstat.common.Promocode' | translate }}"
							[id]="'promocode'"
						>
							<ng-template ngbPanelContent>
								<form class="form-horizontal">
									<label class="col-sm-4 control-label">
										{{ 'adminstat.billing.billing.mark' | translate }}
									</label>
									
									<div class="col-sm-8">
										<ng-selectize
											[config]="selectize.config"
											[options] = "selectize.options"
											[(ngModel)]="filter.filterParams.promocodeMark"
											[ngModelOptions]="{standalone: true}"
										>
										</ng-selectize>
									</div>
								</form>
								
								<form
									class="form-horizontal"
									*ngIf="filter.filterParams.isPromocode"
								>
									<label class="col-sm-4 control-label">
										{{ 'adminstat.billing._promocode.type date' | translate }}
									</label>
									
									<div class="col-sm-8">
										<select
											class="form-control"
											[(ngModel)]="filter.filterParams.chartDateType"
											[ngModelOptions]="{standalone: true}"
										>
											<option
												*ngFor="let opt of ['promocode', 'site', 'user']"
												value="{{ opt }}"
												[selected]="opt == filter.filterParams.chartDateType"
											>
												{{ 'adminstat.billing._promocode.from ' + opt + ' date create' | translate }}
											</option>
										</select>
									</div>
								</form>
								
								<form class="form-horizontal">
									<div class="form-group">
										<div class="checkbox">
											<label>
												<input
													type="checkbox"
													[(ngModel)]="filter.filterParams.hasPaidWithPromocode"
													[ngModelOptions]="{standalone: true}"
													[checked]="filter.filterParams.hasPaidWithPromocode"
												/>
												
												{{ 'adminstat.filterForm.hasPaidWithPromocode' | translate }}
											</label>
										</div>
									</div>
								</form>
							</ng-template>
						</ngb-panel>
					</ngb-accordion>
				</div>
				
				<!-- Anti frod -->
				<div class="col-xl-4 col-lg-6 col-md-12 padding-bottom">
					<ngb-accordion #acc="ngbAccordion" (panelChange)="onAccordionClick($event)" [activeIds]="expandIds">
						<ngb-panel title="{{ 'adminstat.filterForm.Anti fraud' | translate }}" [id]="'antifraud'">
							<ng-template ngbPanelContent>
								<form class="form-horizontal">
									<div class="form-group">
										<div class="checkbox">
											<label>
												<input type="checkbox" [(ngModel)]="filter.filterParams.excludePaidWithFrod1" [ngModelOptions]="{standalone: true}" [checked]="filter.filterParams.excludePaidWithFrod1">
												{{ 'adminstat.filterForm.excludePaidWithFrod1' | translate }}
											</label>
										</div>
									</div>
								</form>
								
								<form class="form-horizontal">
									<div class="form-group">
										<div class="checkbox">
											<label>
												<input type="checkbox" [(ngModel)]="filter.filterParams.excludeRefundFrod1" [ngModelOptions]="{standalone: true}" [checked]="filter.filterParams.excludeRefundFrod1">
												{{ 'adminstat.filterForm.excludeRefundFrod1' | translate }}
											</label>
										</div>
									</div>
								</form>
								
								
								<form class="form-horizontal">
									<div class="form-group">
										<div class="checkbox">
											<label>
												<input type="checkbox" [(ngModel)]="filter.filterParams.excludePromoFrod1" [ngModelOptions]="{standalone: true}" [checked]="filter.filterParams.excludePromoFrod1">
												{{ 'adminstat.filterForm.excludePromoFrod1' | translate }}
											</label>
										</div>
									</div>
								</form>
								
								<form class="form-horizontal">
									<div class="form-group">
										<div class="checkbox">
											<label>
												<input type="checkbox" [(ngModel)]="filter.filterParams.excludePublishFrod1" [ngModelOptions]="{standalone: true}" [checked]="filter.filterParams.excludePublishFrod1">
												{{ 'adminstat.filterForm.excludePublishFrod1' | translate }}
											</label>
										</div>
									</div>
								</form>

								<form class="form-horizontal">
									<div class="form-group">
										<div class="checkbox">
											<label>
												<input
													type="checkbox"
													[(ngModel)]="filter.filterParams.excludeCountActionsFrod1"
													[ngModelOptions]="{standalone: true}"
													[checked]="filter.filterParams.excludeCountActionsFrod1"
												/>
												
												{{ 'adminstat.filterForm.excludeCountActionsFrod1' | translate }}
											</label>
										</div>
									</div>
								</form>

								<form class="form-horizontal">
									<div class="form-group">
										<div class="checkbox">
											<label>
												<input
														type="checkbox"
														[(ngModel)]="filter.filterParams.excludeQuiz"
														[ngModelOptions]="{standalone: true}"
														[checked]="filter.filterParams.excludeQuiz"
												/>

												{{ 'adminstat.filterForm.excludeQuiz' | translate }}
											</label>
										</div>
									</div>
								</form>

								<form class="form-horizontal">
									<div class="form-group">
										<div class="checkbox">
											<label>
												<input
														type="checkbox"
														[(ngModel)]="filter.filterParams.excludeSitebox"
														[ngModelOptions]="{standalone: true}"
														[checked]="filter.filterParams.excludeSitebox"
												/>

												{{ 'adminstat.filterForm.excludeSitebox' | translate }}
											</label>
										</div>
									</div>
								</form>
							</ng-template>
						</ngb-panel>
					</ngb-accordion>
				</div>
			</div>
			
			
			<br>
			
			<div class="row">
				<div class="col-md-12">
					<button type="button" class="btn btn-success" (click)="applyFilters()" [sextant]="'btnApplyFilters'">{{ 'adminstat.common.Apply' | translate }}</button>
					<button type="button" class="btn btn-link" style="color:red;" (click)="resetFilters()" [sextant]="'btnResetFilters'">{{ 'adminstat.common.Reset filters' | translate }}</button>
				</div>
			</div>
		</ng-template>
	</ngb-panel>
</ngb-accordion>

<hr>

<div class="row">
	<div
		class="col"
	    *ngIf="(filter.filterPanelParams | keys).length > 0"
	>
		<div class="tag-list">
			{{ 'adminstat.filterForm.filter list' | translate }}
			
			<button
				type="button"
				class="btn btn-outline-success"
				*ngFor="let param of filter.filterPanelParams | keys"
				[attr.data-key]="param"
				[attr.data-val]="param"
			>
				{{ param }}:
				{{ filter.filterPanelParams[param] }}
			</button>
		</div>
	</div>
	
	<div class="col-md-auto">
		<i
			class="fas fa-code"
			aria-hidden="true"
			(click)="showReporQueries()"
			style="cursor: pointer; opacity: 0.3;"
		></i>
	</div>
</div>

<br>
